/* eslint-disable class-methods-use-this */

import {AtomParamTypesEnum} from '../expressionAtomModel';
import {buildEnumParameter, buildParameter} from '../expressionParamHelpers';
import {
  baseMethods,
  ContactResult,
  DateTimeResult,
  ListMethod,
  MethodCategoriesEnum,
  ResultType,
  ResultTypesEnum,
  StringMethod,
  StringResult,
  TeammateResult,
} from './internal';

enum RecipientRolesEnum {
  FROM = 'from',
  TO = 'to',
  CC = 'cc',
  BCC = 'bcc',
  TO_CC = 'to_cc',
  ALL_RECIPIENTS = 'all',
}

class GetRecipients extends ListMethod {
  constructor() {
    super(MethodCategoriesEnum.TRANSFORM, ContactResult);
  }

  getParameters() {
    return [buildEnumParameter('roles', RecipientRolesEnum, RecipientRolesEnum.ALL_RECIPIENTS)];
  }
}

class GetHeader extends StringMethod {
  constructor() {
    super(MethodCategoriesEnum.PROPERTY);
  }

  getParameters() {
    return [buildParameter('name', AtomParamTypesEnum.STRING)];
  }
}

class GetMessageBody extends StringMethod {
  constructor() {
    super(MethodCategoriesEnum.PROPERTY);
  }

  getParameters() {
    return [buildParameter('include_quote', AtomParamTypesEnum.BOOLEAN)];
  }
}

export const messageType: ResultType = {
  name: ResultTypesEnum.MESSAGE,
  properties: {
    id: StringResult,
    date: DateTimeResult,
    subject: StringResult,
    sender: ContactResult,
    author: TeammateResult,
  },
  methods: {
    get_message_body: new GetMessageBody(),
    get_recipients: new GetRecipients(),
    get_header: new GetHeader(),
    detect_language: new StringMethod(MethodCategoriesEnum.TRANSFORM),
    ...baseMethods,
  },
};
